var map = {
	"./Graphics/Example": 7,
	"./Graphics/Example.tsx": 7
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;


//////////////////
// WEBPACK FOOTER
// ./src/docs/examples ^\.\/.*$
// module id = 39
// module chunks = 0